import XviaLogo from '../assets/xvia-logo.png';

export const ASSETS = {
  logos: {
    full: XviaLogo,
    icon: XviaLogo,
  },
} as const;

export type Assets = typeof ASSETS;
